import FilterAssessmentForm from '@/components/Assessment/FilterForm';
import DashboardButton from '@/components/dashboard/DashboardButton';
import ProfileLayout from '@/components/landing/account/ProfileLayout';
import { CloseOutlined, UndoOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, CardHeader } from 'reactstrap';
import AssessmentTable from '../dashboard/assessment/table';
import { getAllAssessmentQuestion } from '@/actions/assessment';
import moment from 'moment';

const MyAssessment = () => {
  const dispatch = useDispatch();

  const userType = useSelector(
    (state: any) => state?.auth?.creds?.user_data?.user_type
  );
  //States
  const [visible, setVisible] = useState(false);
  const [filterForm] = Form.useForm();

  const [query, setQuery] = useState({
    page: 1,
    per_page: 10,
    due_date: '',
    course: '',
    room: '',
    question: '',
  });

  useEffect(() => {
    dispatch(getAllAssessmentQuestion(query, userType));
  }, [query]);

  const dataSource = [];

  const toggleCard = () => {
    setVisible((visible) => !visible);
  };

  const refreshCard = () => {
    filterForm.resetFields();
    setQuery({
      ...query,
      due_date: '',
      course: '',
      room: '',
      question: '',
    });
  };

  const onFinish = (values) => {
    // console.log(values);
    setQuery({
      ...query,
      due_date:
        values?.due_date != undefined
          ? moment(values?.due_date).format('YYYY-MM-DD')
          : '',
      course: values?.course != undefined ? values?.course : '',
      room: values?.room != undefined ? values?.room : '',
      question: values?.question != undefined ? values?.question : '',
    });
  };

  return (
    <ProfileLayout>
      <div className="d-flex align-items-center justify-content-between  mb-3">
        {/* <div className="d-flex align-items-center gap-2">
          <img
            src={'/images/svgs/dashboard/order stroke.svg'}
            width={'32px'}
            height="32px"
          />
          <h3 className="text-dark m-0">My Assessment</h3>
        </div> */}
        <div></div>

        <div className="float-right d-flex gap-2">
          <DashboardButton
            title={'Filter'}
            onClick={toggleCard}
            icon={<i className="fas fa-filter float-right mt-1 ml-1"></i>}
          />
        </div>
      </div>

      {/* Filter */}
      <Card
        className={`${
          visible === false
            ? 'd-none card-action card-reload mt-2 mb-4'
            : 'card-action card-reload mt-2 mb-4 '
        } shadow-none border rounded-lg`}
      >
        <CardHeader>
          <h5 className="m-0"> Filters </h5>
          <div className="actions">
            <UndoOutlined rev="" className="mr-2" size={15} onClick={refreshCard} />
            <CloseOutlined rev="" size={15} onClick={toggleCard} />
          </div>
        </CardHeader>
        <CardBody className="px-4 pt-0">
          <FilterAssessmentForm filterForm={filterForm} onFinish={onFinish} />
        </CardBody>
      </Card>

      <div>
        <AssessmentTable setQuery={setQuery} query={query} />
      </div>
    </ProfileLayout>
  );
};

export default MyAssessment;
